import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

export const SelectMonthYearPicker = ({
  onChange,
  value,
  disabled = false,
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        views={["month", "year"]}
        // value={value ? dayjs(value) : null}
        value={value ? value : null}
        onChange={(val) => onChange(val)}
        className="select-date"
        slotProps={{
          textField: {
            disabled: disabled,
            fullWidth: true,
            InputProps: {
              sx: {
                "& input": {
                  width: "100%",
                  padding: "8.5px 14px",
                  fontFamily: "'PublicSans', 'Siemreap', sans-serif",
                },
              },
            },
          },
        }}
      />
    </LocalizationProvider>
  );
};
